/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(e){
  $(".homeslider").slick({
    slidesToShow: 3,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    centerPadding: "30px",
    responsive: [
      {
        breakpoint: 790,
        settings: "unslick"
      }
    ]
  });

});

$(document).ready(function(e){
  $(".home-image-grid__items .o-layout").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: false,
    centerMode: false,
    centerPadding: "30px",
    lazyLoad: 'ondemand',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 790,
        settings: "unslick"
      }
    ]
  });

});

/////////////////////////////////////////////////////

$(document).on("afterGetCart.ajaxCart", function(e,cart) {
  var item_count = cart.item_count;
  if(item_count < 1) {
    $(".js-cart-full").removeClass("js-cart-full");
  } else {
    $("a.cart-link").addClass("js-cart-full");
  }
});

/////////////////////////////////////////////////////

function cookieBannerAccepted(){
window.__rmcp2=[1,2,3,4,5,6,7,8,9,10];
  Cookies.set("bc-yes", 1);
}
//attach a click event to the 'accept' button of the cookie banner, firing the cookie banner accepted function when clicked
jQuery(document).on('click', '#ba-cookie-dismiss', cookieBannerAccepted);
//check to see if cookie banner has already been accepted, if so fire the cookie banner accepted function
if(document.cookie.indexOf('bc-yes') > -1){cookieBannerAccepted()}

$(document).ready(function(e){
  var cookieValue = Cookies.get("bc-yes");
  if(cookieValue) window.__rmcp2=[1,2,3,4,5,6,7,8,9,10];
});

/////////////////////////////////////////////////////

// RPECK 21/05/2021
// This is if the email form has submitted
$(document).ready(function(e){
  let params = new URLSearchParams(window.location.search);
  if(params.get('customer_posted')) $("#email_success_toggle").prop("checked", true).trigger("change");
});